



















































import DropdownSelect from "@/app/ui/components/DropdownSelect/index.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import NestedMultiSelect  from "../DropdownMultiSelect/index.vue";
import IconPlus from "@/app/ui/assets/ics_f_plus_circle.vue";
import IconTrash from "@/app/ui/assets/trash_icon.vue";


@Component({
  components: {
    DropdownSelect,
    NestedMultiSelect,
    IconTrash,
    IconPlus
  }
})
export default class DeliveryArea extends Vue {
  @Prop({ default: () => [], type: Array  }) value!: Array<any>;
  @Prop({ default: () => [], type: Array}) areaDeliveries!: Array<{label: string, value: string}>;
  @Prop({ default: () => [], type: Array }) districts!: Array<Record<string, {label: string, value: string}>>;

  get filteredAreaDeliveries() {
    const selectedAreas = this.value.map(area => area.cityCode)
    return this.areaDeliveries.filter(area => {
      return !selectedAreas.includes(area.value)
    });
  }

  get isAllRowValid() {
    const isDistrictsValid = this.value.every(v => !!v.districts?.length)
    const isCityCodesValid = this.value.every(v => !!v?.cityCode)
    const isValid = isDistrictsValid && isCityCodesValid;
    this.$emit("is-valid", isValid);
    return isValid
  }

  get isShowAddRow() {
    return this.filteredAreaDeliveries.length;
  }

  public onChangeCity(value: any, index = 9) {
    if (!value) return;
    this.value[index].cityName = value.label;
    this.value[index].cityCode = value.value;
    this.value[index].districtOptions = value.districtOptions;
    this.value[index].districts = [];

    this.$emit("input", this.value);
  }

  public onAddRow() {
    if (this.filteredAreaDeliveries.length === 1) {
      const lastRow = this.filteredAreaDeliveries[0]
      this.$emit("add-row", lastRow);
    } else {
      this.$emit("add-row", undefined);
    }
  }

  public onDeleteRow(index = 0) {
    this.$emit("delete-row", index);
  }

  public getAreaValue(value: any) {
    if (!value.cityCode) return "";
    return {
      label: value?.cityName,
      value: value?.cityCode
    }
  }
}
